/* eslint-disable import/prefer-default-export */
/* eslint-disable no-useless-escape */

const EMPTY_STRING = '';

const EMAIL_REG_EXP = new RegExp(
  '(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))',
);

const SCHEDULE_DATE_REG_EXP = /(\d{4})-(\d{2})-(\d{2})|(\d{4})-(\d{2})/g;

export const DISPLAY_NAME_HAS_NUMBERS = /[()+\-\/\\ ']+/g;

export const validateEmail = email => EMAIL_REG_EXP.test(email);

export const getScheduleDateFromPath = pathname => {
  if (pathname) {
    const pathDateMatch = pathname.match(SCHEDULE_DATE_REG_EXP);

    if (pathDateMatch) {
      return pathDateMatch.join('');
    }

    return EMPTY_STRING;
  }

  return EMPTY_STRING;
};
